import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Features } from "../components/Features";
import { HowItWorks } from "../components/HowItWorks";
import { AboutUs } from "../components/AboutUs";
import { CTA } from "../components/CTA";
import { Footer } from "../components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <Features />
      <HowItWorks />
      <AboutUs />
      <CTA />
      <Footer />
    </div>
  );
};

export default Index;
